import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";

import SharedViewAPI from "../../../api/api/SharedScreenAPI";
import { workspaceIdAtom } from "../../../atoms/WorkspaceAtoms";

interface Props {
  viewID: string | undefined;
  recordID: string | undefined;
  pageID: string | undefined;
  documentID: string | undefined;
}

// For Shared Pages, Views, AND Documents.
export default function useSharedScreenInTenant({
  viewID,
  recordID,
  pageID,
  documentID,
}: Props) {
  const workspaceID = useAtomValue(workspaceIdAtom);

  let queryKey;

  if (documentID) {
    queryKey = ["sharedDocument", documentID];
  } else if (!viewID && pageID) {
    queryKey = ["sharedPage", pageID];
  } else {
    queryKey = ["sharedView", viewID, recordID];
  }

  const sharedScreen = useQuery({
    queryKey: queryKey,
    queryFn: () =>
      SharedViewAPI.getSharedScreenInTenant({
        workspaceID: workspaceID as string,
        viewID,
        recordID,
        pageID,
        documentID,
      }).then((data: any) => {
        return data.data.data;
      }),
    enabled: !!viewID || !!pageID || !!documentID,
  });

  return {
    exists: sharedScreen?.data?.exists || false,
    sharedScreenID: sharedScreen?.data?._id,
    authentication: sharedScreen?.data?.Authentication,
    password: sharedScreen?.data?.Password,
    loading: sharedScreen?.isLoading,
  };
}
